import { ActionTypes } from './actionTypes';
import type { LoadAlarmsFailed, LoadAlarmsRequest, LoadAlarmsSucceeded } from './actions';

import type { Alarm, IncidentsPayload } from '@cobliteam/common-types';

export const loadAlarmsRequest = (alarmsPayload: IncidentsPayload): LoadAlarmsRequest => ({
  type: ActionTypes.LOAD_ALARMS_REQUEST,
  payload: {
    alarmsPayload,
  },
});

export const loadAlarmsSucceeded = (alarms: Alarm[]): LoadAlarmsSucceeded => ({
  type: ActionTypes.LOAD_ALARMS_SUCCEEDED,
  payload: alarms,
});

export const loadAlarmsFailed = (): LoadAlarmsFailed => ({
  type: ActionTypes.LOAD_ALARMS_FAILED,
});
